import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons'
import classNames from 'classnames'
import { useAddTimeCard } from '@features/time-logging/hooks/useAddTimeCard'
import { useTranslation } from 'react-i18next'
import { Spinner } from 'components/loaders'
import { DateTime } from 'luxon'
import { useWeekDates } from '@hooks/useWeekDates'
import { useWeekStartsOn } from '@hooks/useWeekStartsOn'

interface Props {
  date: DateTime
  className?: string
}

function LogTime(props: Props) {
  const weekStartsOn = useWeekStartsOn()
  const { start, end } = useWeekDates({ weekStartsOn })
  const addTimeCardMutation = useAddTimeCard({ date: props.date, start, end })
  const { t } = useTranslation()

  return (
    <div
      data-testid="log-time"
      className={classNames(
        'flex justify-center items-start mt-2',
        props.className,
      )}
    >
      <button
        className="flex gap-2 items-center justify-center text-xs uppercase text-[#8D99A8] cursor-pointer"
        onClick={addTimeCardMutation.mutate}
        disabled={addTimeCardMutation.isLoading}
      >
        {addTimeCardMutation.isLoading ? (
          <Spinner />
        ) : (
          <FontAwesomeIcon icon={faCirclePlus} className="text-sm" />
        )}

        {t('features.timeLogging.logTime')}
      </button>
    </div>
  )
}

export default LogTime
